<div class="table-section">
  <loading class="loading-container" [isLoading]="isLoading" ></loading>

  <div class="chart-container">

    <div class="chart-header">
      <h2>Alarmas en el mes de {{currentMonth}}</h2>

      <div class="table-button" *ngIf="('Alarmas' | permissionFilter) && chartData?.datasets[0]?.data?.length > 0">
        <button class="btn-agregar">
          <span (click)="openAlarmsTable()">Ver historial</span>
        </button>
      </div>
      
    </div>

    <div class="chart-canvas-container" *ngIf="chartData?.datasets[0]?.data?.length > 0">
      <canvas class="chart"
        baseChart
        [data]="chartData"
        [type]="'line'"
        [options]="chartOptions"
        (chartClick)="onChartClick($event)">
      </canvas>
    </div>

    <div class="no-result-item" *ngIf="!isLoading && (!chartData?.datasets[0]?.data?.length || chartData?.datasets[0]?.data?.length === 0)">
      <h1>No se encontraron datos</h1>
    </div>
  </div>

</div>